import clsx from "clsx";
import React, { FC } from "react";

import { Cta } from "../buttons/cta";

export interface FooterInnerCardProps {
  title: string | null;
  abstract?: string | null;
  cta: Queries.CtaDataFragment | null;
  onClickCta?: () => void;
  variant?: "light" | "primary";
}

export const FooterInnerCard: FC<FooterInnerCardProps> = ({
  title,
  abstract,
  cta,
  variant = "light",
  onClickCta,
}) => {
  return (
    <div className="inline-flex flex-col w-full items-start">
      <div className="text-xl text-white mb-1 lg:mb-4 font-medium">{title}</div>
      <hr
        className={clsx(
          "w-full mt-2 mb-6 border-t-2",
          variant === "light" && "border-gray-400",
          variant === "primary" && "border-primary"
        )}
      />
      <div className="text-xs md:text-sm xl:text-md text-white mb-7 lg:max-w-sm xl:max-w-md 2xl:max-w-lg leading-4">
        {abstract}
      </div>
      {cta && (
        <Cta
          {...cta}
          onClick={onClickCta}
          variant={variant === "light" ? "primary-inverted" : "primary-light"}
          className="md:text-sm xl:text-md"
        />
      )}
    </div>
  );
};
